import { WmsService } from '../resource'

const WmsPartnerModule = {
  namespaced: true,
  state: {
    data: []
  },
  mutations: {
    SET_DATA (state, data) {
      state.data = data
    }
  },
  actions: {
    createData ({ commit, state }, data) {
        return WmsService.PartnerCreate(data)
    },
    updateData ({ commit, state }, data) {
        return WmsService.PartnerUpdate(data.id,data.payload)
    },
    deleteData ({ commit, state }, data) {
        return WmsService.PartnerDelete(data)
    },
    async listData ({ commit, state }) {
      try{

      
        const data = await WmsService.PartnerList()
        if (data.data.Data == null) 
        {
          commit('SET_DATA', [])
        }
        else 
        {
          commit('SET_DATA', data.data.Data)
        }
      }
      catch(err)
      {
        commit('SET_DATA', [])
      }
    }
  },
  getters: {
    getData (state) {
      return state.data
    }
  }
}

export default WmsPartnerModule